module.exports = __webpack_public_path__ + "img/heart-animation2.ca97bde3.gif";